<div>
  <p class="heading">We’ll need an Email Id to reach you on</p>
  <app-email-verification-form></app-email-verification-form>

  <div class="row">
    <div class="col-xs-6">
      <button mat-stroked-button class="button-back primary" (click)='navigateBack()'><i
        class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp; BACK
      </button>
    </div>

    <div class="col-xs-6">
      <app-forward-button class="button-forward pull-right" [isLoading]="loaderStatus.isLoading"
                          (click)="navigateNext(); analyticsTracker.trackButtonClick('Email Verification', 'NEXT');">NEXT
      </app-forward-button>
    </div>
  </div>
</div>
